import { getCookie, removeCookie, setCookie } from '../util_functions';

const STAGING_API_ENVIRONMENT_COOKIE_KEY = 'hridaya_staging_api_host';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 30;

export const DEFAULT_STAGING_API_HOST = 'gstg1.myyogateacher.com';
export const SECONDARY_STAGING_API_HOST = 'gstg2.myyogateacher.com';

export const STAGING_API_ENVIRONMENT_OPTIONS = [
  {
    value: DEFAULT_STAGING_API_HOST,
    label: DEFAULT_STAGING_API_HOST,
    description: 'Default staging endpoint'
  },
  {
    value: SECONDARY_STAGING_API_HOST,
    label: SECONDARY_STAGING_API_HOST,
    description: 'Alternate staging endpoint'
  }
];

const PRODUCTION_API_HOST = 'gapi.myyogateacher.com';
const PRODUCTION_CHAT_HOST = 'samvaad.myyogateacher.com';
const PRODUCTION_SOCKET_HOST = 'samvaad.azure-services.myyogateacher.com';
const STAGING_CHAT_HOST = 'samvaad-gstg1.myyogateacher.com';

const VALID_STAGING_API_HOSTS = STAGING_API_ENVIRONMENT_OPTIONS.map(({ value }) => value);

const isProductionStage = () => import.meta.env.VITE_APP_STAGE === 'production';

const getValidApiHost = (value) => {
  if (VALID_STAGING_API_HOSTS.includes(value)) {
    return value;
  }

  return null;
};

const saveSelectedApiHostCookie = (host) => {
  setCookie(STAGING_API_ENVIRONMENT_COOKIE_KEY, host, COOKIE_MAX_AGE);
};

const removeSelectedApiHostCookie = () => {
  removeCookie(STAGING_API_ENVIRONMENT_COOKIE_KEY);
};

const getStoredStagingApiHost = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_STAGING_API_HOST;
  }

  const cookieValue = getValidApiHost(getCookie(STAGING_API_ENVIRONMENT_COOKIE_KEY));

  if (cookieValue) {
    return cookieValue;
  }

  return DEFAULT_STAGING_API_HOST;
};

export const getSelectedApiHost = () => {
  if (isProductionStage()) {
    return PRODUCTION_API_HOST;
  }

  return getStoredStagingApiHost();
};

export const setSelectedApiHost = (host) => {
  if (!VALID_STAGING_API_HOSTS.includes(host)) {
    throw new Error(`Unsupported API host: ${host}`);
  }

  if (typeof window === 'undefined') {
    return;
  }

  if (host === DEFAULT_STAGING_API_HOST) {
    removeSelectedApiHostCookie();
    return;
  }

  saveSelectedApiHostCookie(host);
};

export const getApiEnvironmentConfig = () => {
  if (isProductionStage()) {
    return {
      apiHost: PRODUCTION_API_HOST,
      apiDomain: `https://${PRODUCTION_API_HOST}`,
      mytChatHost: PRODUCTION_CHAT_HOST,
      socketHost: PRODUCTION_SOCKET_HOST,
      goDomain: `https://${PRODUCTION_API_HOST}`
    };
  }

  const apiHost = getStoredStagingApiHost();

  return {
    apiHost,
    apiDomain: `https://${apiHost}`,
    mytChatHost: STAGING_CHAT_HOST,
    socketHost: apiHost,
    goDomain: `https://${apiHost}`
  };
};
